export default __webpack_public_path__ + "static/media/scan-icon.3fddf253.svg";